module.exports = __webpack_public_path__ + "static/rtl-logo-4f640c5a62a2c59ad568a62bdb1fb815.png";